export const load = () => ({
	title: 'Noise Disclaimer',
	description: 'Understanding How Indow Inserts Reduce Noise',
	showTitle: false,
});
